module.exports = __webpack_public_path__ + "img/faces-mosaic.e6f9bc4d.jpg";